import type { ReactNode } from 'react';

interface MembersManagementPanelProps {
  readonly toolbar?: ReactNode;
  readonly table: ReactNode;
  readonly pagination?: ReactNode;
}

export function MembersManagementPanel({
  toolbar,
  table,
  pagination,
}: MembersManagementPanelProps) {
  return (
    <div className="overflow-hidden rounded-[var(--radius-surface-4xl)] border border-border/70 bg-card">
      {toolbar}
      {table}
      {pagination}
    </div>
  );
}
